@if (active) {
	<div class="saving-overlay" role="status" aria-live="polite" [attr.aria-label]="message">
		<div class="saving-overlay-box">
			<div class="saving-overlay-spinner"></div>
			<span class="saving-overlay-message">{{ message }}</span>
		</div>
	</div>
}
